module.exports = __webpack_public_path__ + "static/media/manager schoolbusyellow.ef644c88.svg";